import { Box } from '@mui/material';
import {
  CustomTextField,
  CustomAutoComplete,
  HorizontalForm,
  VerticalForm,
  DialogTitle,
} from '../../../common/components';

const ContactDataSection = ({
  selectedSubcontractor,
  onInputChange,
  onSelectChange,
  isMobile,
  countries,
  provinces,
  departments,
  districts,
  locationState,
  setLocationState,
}) => {
  const handleLocationChange = (event) => {
    const { name, value } = event.target;

    if (name === 'uuid_country') {
      setLocationState((prev) => ({
        ...prev,
        country: countries.find((c) => c.uuid === value),
        province: null,
        department: null,
        district: null,
      }));
    } else if (name === 'uuid_province') {
      setLocationState((prev) => ({
        ...prev,
        province: provinces.find((p) => p.uuid === value),
        department: null,
        district: null,
      }));
    } else if (name === 'uuid_department') {
      setLocationState((prev) => ({
        ...prev,
        department: departments.find((d) => d.uuid === value),
        district: null,
      }));
    } else if (name === 'uuid_district') {
      setLocationState((prev) => ({
        ...prev,
        district: districts.find((d) => d.uuid === value),
      }));
    }

    onSelectChange(event);
  };

  const filteredProvinces = provinces.filter((p) => p.uuid_country === locationState.country?.uuid);

  const filteredDepartments = departments.filter(
    (d) => d.uuid_province === locationState.province?.uuid
  );

  const filteredDistricts = districts.filter(
    (d) => d.uuid_department === locationState.department?.uuid
  );

  return (
    <Box>
      <DialogTitle showSeparator={false} sx={{ p: 0 }}>
        Datos de contacto y ubicación
      </DialogTitle>
      {isMobile ? (
        <VerticalForm>
          <CustomTextField
            label="Dirección"
            name="address"
            value={selectedSubcontractor.address || ''}
            onChange={onInputChange}
            size="medium"
          />
          <CustomTextField
            label="Código postal"
            name="postal_code"
            value={selectedSubcontractor.postal_code || ''}
            onChange={onInputChange}
            size="medium"
          />
          <CustomAutoComplete
            label="País"
            name="uuid_country"
            value={selectedSubcontractor.uuid_country || ''}
            onChange={handleLocationChange}
            options={countries.map((country) => ({
              value: country.uuid,
              label: country.name,
            }))}
            size="medium"
          />
          <CustomAutoComplete
            label="Provincia"
            name="uuid_province"
            value={selectedSubcontractor.uuid_province || ''}
            onChange={handleLocationChange}
            options={filteredProvinces.map((province) => ({
              value: province.uuid,
              label: province.name,
            }))}
            size="medium"
            disabled={!locationState.country}
          />
          <CustomAutoComplete
            label="Departamento"
            name="uuid_department"
            value={selectedSubcontractor.uuid_department || ''}
            onChange={handleLocationChange}
            options={filteredDepartments.map((department) => ({
              value: department.uuid,
              label: department.name,
            }))}
            size="medium"
            disabled={!locationState.province}
          />
          <CustomAutoComplete
            label="Distrito"
            name="uuid_district"
            value={selectedSubcontractor.uuid_district || ''}
            onChange={handleLocationChange}
            options={filteredDistricts.map((district) => ({
              value: district.uuid,
              label: district.name,
            }))}
            size="medium"
            disabled={!locationState.department}
          />
          <CustomTextField
            label="Teléfono"
            name="phone_number"
            value={selectedSubcontractor.phone_number || ''}
            onChange={onInputChange}
            size="medium"
          />
          <CustomTextField
            label="Email"
            name="email"
            type="email"
            value={selectedSubcontractor.email || ''}
            onChange={onInputChange}
            size="medium"
          />
          <CustomTextField
            label="Información de contacto"
            name="contact_information"
            value={selectedSubcontractor.contact_information || ''}
            onChange={onInputChange}
            size="medium"
            multiline
            rows={2}
          />
        </VerticalForm>
      ) : (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <HorizontalForm withBorder={false} sx={{ p: 1 }}>
            <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 2, mr: 4 }}>
              <CustomTextField
                label="Dirección"
                name="address"
                value={selectedSubcontractor.address || ''}
                onChange={onInputChange}
                size="medium"
              />
              <CustomTextField
                label="Código postal"
                name="postal_code"
                value={selectedSubcontractor.postal_code || ''}
                onChange={onInputChange}
                size="medium"
              />
              <CustomAutoComplete
                label="País"
                name="uuid_country"
                value={selectedSubcontractor.uuid_country || ''}
                onChange={handleLocationChange}
                options={countries.map((country) => ({
                  value: country.uuid,
                  label: country.name,
                }))}
                size="medium"
              />
            </Box>
            <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 2 }}>
              <CustomTextField
                label="Teléfono"
                name="phone_number"
                value={selectedSubcontractor.phone_number || ''}
                onChange={onInputChange}
                size="medium"
              />
              <CustomTextField
                label="Email"
                name="email"
                type="email"
                value={selectedSubcontractor.email || ''}
                onChange={onInputChange}
                size="medium"
              />
              <CustomAutoComplete
                label="Provincia"
                name="uuid_province"
                value={selectedSubcontractor.uuid_province || ''}
                onChange={handleLocationChange}
                options={filteredProvinces.map((province) => ({
                  value: province.uuid,
                  label: province.name,
                }))}
                size="medium"
                disabled={!locationState.country}
              />
            </Box>
          </HorizontalForm>

          <HorizontalForm withBorder={false} sx={{ p: 1 }}>
            <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 2, mr: 4 }}>
              <CustomAutoComplete
                label="Departamento"
                name="uuid_department"
                value={selectedSubcontractor.uuid_department || ''}
                onChange={handleLocationChange}
                options={filteredDepartments.map((department) => ({
                  value: department.uuid,
                  label: department.name,
                }))}
                size="medium"
                disabled={!locationState.province}
              />
              <CustomTextField
                label="Información de contacto"
                name="contact_information"
                value={selectedSubcontractor.contact_information || ''}
                onChange={onInputChange}
                size="medium"
                multiline
                rows={2}
              />
            </Box>
            <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 2 }}>
              <CustomAutoComplete
                label="Distrito"
                name="uuid_district"
                value={selectedSubcontractor.uuid_district || ''}
                onChange={handleLocationChange}
                options={filteredDistricts.map((district) => ({
                  value: district.uuid,
                  label: district.name,
                }))}
                size="medium"
                disabled={!locationState.department}
              />
            </Box>
          </HorizontalForm>
        </Box>
      )}
    </Box>
  );
};

export default ContactDataSection;
